module.exports = __webpack_public_path__ + "static/img/bg-pt.ee2736c1.png";